import vueUIInitiator from '../../modules/vue-ui-initiator';
import IndicatorsBlock from '../../vue-components/IndicatorsBlock';
import ImageSlider from '../../vue-components/ImageSlider';

vueUIInitiator('js--indicators-block-init', IndicatorsBlock, 'indicators-block');
vueUIInitiator('js--slider-init', ImageSlider, 'image-slider');
